import { formatDNI } from '@chilecompra/react-kit/utils'
import { IDENTIFICATION_TYPE } from '../../config/settings/constants'

/* Get persons array from service */
export const getPersonsFromServiceData = serviceData => {
  return serviceData.map(person => {
    return {
      lastNamePaternal: person.apellidoPaterno,
      lastNameMaternal: person.apellidoMaterno,
      lastNames: `${person.apellidoPaterno} ${person.apellidoMaterno}`,
      name: person.nombre,
      dni: formatDNI(person.rut),
      typeIdentificationId: IDENTIFICATION_TYPE.RUT
    }
  })
}

/* Get name from 'signerSelectValue' */
export const createNameComplete = data => {
  if (data.signerSelectValue?.name) {
    return [
      [data.signerSelectValue.name, data.signerSelectValue.lastNamePaternal].join(' ').trim(),
      data.signerSelectValue.lastNameMaternal
    ]
      .join(' ')
      .trim()
  }
  const lastNamePaternal = data.lastNamePaternal || ''
  const lastNameMaternal = data.lastNameMaternal || ''
  return [[data.name, lastNamePaternal].join(' ').trim(), lastNameMaternal].join(' ').trim()
}
